export default __webpack_public_path__ + "static/media/img4.b293465b.jpg";